import { memo } from 'react';

import { Box } from '@zillow/constellation-10';
import PropertyCardSimple from '../components/PropertyCardSimple';

import type { PropertyProps } from '../../../model/Property';

type Props = {
  listings?: Array<PropertyProps>;
};

const GroupablePropertiesViewGrid = ({ listings = [] }: Props): JSX.Element => {
  return (
    <Box data-testid="PropertiesViewGrid" css={{ display: 'flex', gap: '600', flexWrap: 'wrap' }}>
      {listings.map((listingModel, index) => {
        return <PropertyCardSimple key={`PropertyCardSimple-${index}`} listing={listingModel} />;
      })}

      {Array(2)
        .fill(1)
        .map((_, i) => (
          <Box
            key={`PropertyCardSimplePlaceHolder-${i}`}
            css={{ flex: '1 1 30%', minWidth: '{sizes.PropertyCard.Root.large.min}' }}
          />
        ))}
    </Box>
  );
};

export default memo(GroupablePropertiesViewGrid);
